export default __webpack_public_path__ + "static/media/OnlineShopping.636144d7.svg";